import React, { Component } from 'react'
import { Route, Switch } from 'dva/router'
import routes from './router'

import Mtop from './common/lib/mtop'
import Header from './common/Header'
import Footer from './common/Footer'
import './common/global.css'

import styles from './App.module.less'

class App extends Component {
  constructor (props) {
    super(props)
    if (__isBrowser__ && window && window.lib.mtop) {
      Mtop.config('prefix', 'acs')
      Mtop.config('subDomain', '')
      Mtop.config('mainDomain', 'youku.com')
      Mtop.config('appKey', '24679788')
    }
  }

  changeHeaderState () {
    this.refs.Header && this.refs.Header.setState({ isWhite: true })
  }
  componentDidMount () {
    this._isMounted = true
    if (__isBrowser__) {
      window.Header = {
        changeState: (state) => {
          if (this._isMounted) {
            this.refs.Header.setState({ focusWhite: state })
          }
        }
      }
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  render () {
    return (
      <div className={`${styles.normal} window`}>
        <Header ref='Header' />
        <Switch>{routes.map(({ path, exact, component: Component }) => { return <Route key={path} path={path} exact={exact} component={Component} /> })}</Switch>
        <Footer />
      </div>
    )
  }
}

export default App
